import { FieldValues, useForm as useReactHookForm, UseFormProps } from "react-hook-form";
import { ZodSchema } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

type UseFunnelFormProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  Schema = any,
> = {
  schema?: ZodSchema<Schema>;
} & UseFormProps<TFieldValues, TContext>;

export function useForm<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  Schema = any,
>({ schema, ...useFormProps }: UseFunnelFormProps<TFieldValues, TContext, Schema>) {
  return useReactHookForm<TFieldValues, TContext>({
    resolver: schema ? zodResolver(schema) : undefined,
    mode: "onChange",
    reValidateMode: "onChange",
    delayError: 500,
    ...useFormProps,
  });
}
